<template lang="pug">
  .poland
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/poland-min.png"
      )
      span {{ gettext('Польша') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Польша одна из стран Европейского Союза  которая всегда пленила своей богатой историей, памятниками старины, культурными достижениями, живописными ландшафтами, и прежде всего гостеприимством и дружелюбием жителей.Это крупнейшая страна в Восточной Европе, занимающая по размерам своей территории 9-е место в Европе. Польша граничит на востоке с Российской Федерацией, Беларусью, Украиной и Литвой, на юге с Чешской республикой и Словацкой Республикой и на западе с Германией. На севере находится Балтийское море.') }}
        p {{ gettext('Государственный язык – польский, но большинство понимают русский и украинский язык, английский язык  понимают но почти не пользуются, поэтому адаптация происходит намного быстрее чем в других странах Европейского Союза. Население Польши около 38,6 млн. человек. В стране проживает много украинцев, белорусов, армян. Крупнейшие польские города — это Варшава (столица РП, около 1,7 млн. жителей), Лодзь, Краков, Вроцлав, Познань, Гданьск.') }}
        p {{ gettext('Работать в Польшу едут многие граждане соседних стран, несмотря на небольшие заработные платы, уровень жизни в Польше достойный, как и условия работы, что и привлекают так много трудовых мигрантов.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/poland-min.png'})
  },
  name: 'Poland',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Poland | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/poland/index.vue